document.addEventListener('DOMContentLoaded', function () {
	// Find the child of '.gtranslate_wrapper' with class 'gt-current-lang'
	const navigationBlocksTranslate =
		document.querySelectorAll('.block-navigation');
	const gtranslateButtonContainer = document.querySelector(
		'.block-navigation-translate-button'
	);
	const gtranslateWrapper = document.querySelector('.gtranslate_wrapper');
	const currentLangElement =
		gtranslateWrapper.querySelector('.gt-current-lang');
	const addValueHereDiv = document.querySelector('.add-value-here');

	// Set the initial value of '.add-value-here' based on the current language element
	if (currentLangElement && currentLangElement.getAttribute('data-gt-lang')) {
		addValueHereDiv.textContent =
			currentLangElement.getAttribute('data-gt-lang');
	} else {
		addValueHereDiv.textContent = 'hi';
	}

	// Update the value when a user clicks on any child of '.gtranslate_wrapper'
	gtranslateButtonContainer.addEventListener('click', function () {
		document.body.classList.toggle('translation-active');
		// Only add 'active' if 'active-nav-links' is not already present on the body
		if (!document.body.classList.contains('active-nav-links')) {
			if (navigationBlocksTranslate) {
				navigationBlocksTranslate.forEach((element) => {
					element.classList.add('active');
				});
			}
		}
	});

	// Update the value when a user clicks on any child of '.gtranslate_wrapper'
	gtranslateWrapper.addEventListener('click', function (event) {
		const clickedElement = event.target;
		if (clickedElement.hasAttribute('data-gt-lang')) {
			addValueHereDiv.textContent =
				clickedElement.getAttribute('data-gt-lang');
		}
	});

	window.addEventListener('resize', moveDiv);
	window.addEventListener('DOMContentLoaded', moveDiv); // To move div on page load as well

	function moveDiv() {
		const movableDiv = document.querySelector(
			'.block-navigation-translate-button'
		);
		const movableLogin = document.querySelector(
			'.block-navigation-login-link'
		);
		// const targetDiv = document.querySelector(
		// 	'button.block-navigation__hamburger'
		// );
		const targetDiv = document.querySelector(
			'.block-navigation__container'
		);
		const translateParentDiv = document.querySelector(
			'.block-navigation__menu'
		);
		const loginParentDiv = document.querySelector(
			'.block-navigation-top__menu'
		);
		const screenWidth = window.innerWidth;

		if (screenWidth < 1200) {
			targetDiv.appendChild(movableDiv); // Moves the div next to '.movehere'
			targetDiv.appendChild(movableLogin); // Moves the div next to '.movehere'
		} else {
			// Optionally, move it back to its original position when the screen is wider
			const originalParent = translateParentDiv; // Change this to the original parent element
			const originaLoginParent = loginParentDiv; // Change this to the original parent element
			originalParent.appendChild(movableDiv);
			originaLoginParent.appendChild(movableLogin);
		}
	}
});
